import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

/**
 * Переключатель тактильной отдачи (стори 3.1). Хранится по образцу визуальной темы:
 * localStorage в вебе, защищённое хранилище на устройстве.
 */

const KEY = 'svyaz_haptics_enabled';

/** Умолчание — включено: без отдачи приложение ощущается мёртвым, ради этого пункт и заводили. */
export const HAPTICS_ENABLED_BY_DEFAULT = true;

function isWeb(): boolean {
  return Platform.OS === 'web';
}

export async function readHapticsEnabled(): Promise<boolean> {
  let raw: string | null;
  if (isWeb()) {
    try {
      raw = typeof globalThis.localStorage === 'undefined' ? null : globalThis.localStorage.getItem(KEY);
    } catch {
      raw = null;
    }
  } else {
    try {
      raw = await EncryptedStorage.getItem(KEY);
    } catch {
      raw = null;
    }
  }
  // Ничего не записано — умолчание. Только явное «0» выключает: любое другое значение,
  // включая мусор от прошлых версий, безопаснее прочитать как «включено», чем молча
  // лишить человека отдачи, которую он не выключал.
  return raw === null ? HAPTICS_ENABLED_BY_DEFAULT : raw !== '0';
}

export async function writeHapticsEnabled(enabled: boolean): Promise<void> {
  const value = enabled ? '1' : '0';
  if (isWeb()) {
    try {
      globalThis.localStorage?.setItem(KEY, value);
    } catch {
      /* noop */
    }
    return;
  }
  try {
    await EncryptedStorage.setItem(KEY, value);
  } catch {
    /* noop */
  }
}
